// extracted by mini-css-extract-plugin
export var copyIcon = "_rv-2";
export var discountCard = "_rv-0";
export var discountCode = "_rv-3";
export var discountContent = "_rv-1";
export var loadingCard = "_rv-4";